import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router';

export class CustomReuseStrategy implements RouteReuseStrategy {

  private storedRoutes = new Map<string, DetachedRouteHandle>();

  // 🔹 Determina si la ruta debe guardarse
  // shouldDetach(route: ActivatedRouteSnapshot): boolean {
  //   if (!route.routeConfig || route.routeConfig.loadChildren) {
  //     return false;
  //   }

  //   console.log('🟡 shouldDetach:', this.getFullRouteUrl(route));
  //   return true;
  // }


  // 🔹 Determina si la ruta debe guardarse
shouldDetach(route: ActivatedRouteSnapshot): boolean {

  if (!route.routeConfig || route.routeConfig.loadChildren) {
    return false;
  }

  const url = this.getFullRouteUrl(route);

  console.log('🟡 shouldDetach:', url);

  // ❌ No guardar rutas que contengan "nueva"
  if (url.toLowerCase().includes('nueva') || 
    url.toLowerCase().includes('nuevo')) {
    return false;
  }

  return true;
}



  // 🔹 Guarda el componente en memoria
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const url = this.getFullRouteUrl(route);
    console.log('🟢 store:', url);

    if (url) {
      this.storedRoutes.set(url, handle);
    }
  }

  //🔹 Determina si debe restaurar el componente guardado
   shouldAttach(route: ActivatedRouteSnapshot): boolean {
     const url = this.getFullRouteUrl(route);
     const exists = this.storedRoutes.has(url);

     console.log('🔵 shouldAttach:', url, exists);
   return exists;
   }


  

  // 🔹 Devuelve el componente guardado
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const url = this.getFullRouteUrl(route);
    console.log('🟣 retrieve:', url);

    if (!route.routeConfig || route.routeConfig.loadChildren) {
      return null;
    }

    return this.storedRoutes.get(url) || null;
  }

  // 🔹 Decide si Angular debe reutilizar la misma ruta
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  // 🔹 Obtener URL completa (soporta rutas hijas)
  private getFullRouteUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .filter(v => v)
      .join('/');
  }

  // 🔹 Método opcional para eliminar cache (cuando cierres tab)
  public clearRoute(url: string): void {
    console.log('🗑️ clearRoute:', url);
    url = url.replace(/^\/+/, '');
    this.storedRoutes.delete(url);
  }

  // 🔹 Limpiar todo
  public clearAll(): void {
    console.log('🗑️ clearAll cache');
    this.storedRoutes.clear();
  }
}